import React from 'react';
import { withTranslation } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Card from '@material-ui/core/Card';
import CircularProgress from '@material-ui/core/CircularProgress';
import PrinterMap from './PrinterMap';

const SelectPrinterDialog = ({ open, loading, printers, apiKey, onPrinterSelected, isPhotoMode, onClose, t }) => {
  const handleClose = onClose || (() => {});

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>
        {t('choosePrinter')}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          style={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText />
        {loading && (
          <Card style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400 }}>
            <CircularProgress />
          </Card>
        )}
        {!loading && (
          <PrinterMap
            apiKey={apiKey}
            printers={printers}
            loading={false}
            onPrinterSelected={onPrinterSelected}
            showPhoto={isPhotoMode}
            showDocument={!isPhotoMode}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default withTranslation()(SelectPrinterDialog);

